import { render, staticRenderFns } from "./TestimonialSection.vue?vue&type=template&id=50900164&"
import script from "./TestimonialSection.vue?vue&type=script&lang=js&"
export * from "./TestimonialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports